import { useQuery } from "@lookiero/messaging-react";
import { viewGameByCustomerId } from "../../../../projection/game/viewGameByCustomerId";
import { MESSAGING_CONTEXT_ID } from "../../../delivery/baseBootstrap";
const useViewGameByCustomerId = ({ customerId }) => useQuery({
    query: viewGameByCustomerId({ customerId }),
    contextId: MESSAGING_CONTEXT_ID,
    options: {
        staleTime: Infinity,
        retry: false,
        refetchOnWindowFocus: false,
    },
});
export { useViewGameByCustomerId };
